import React, { useContext, useState } from 'react';
import { func } from 'prop-types';
import { Box, Button, IconButton, Typography } from '@mui/material';

import { format, parseISO, startOfToday, startOfTomorrow } from 'date-fns';
import { DatePicker } from '@mui/x-date-pickers';

import { ExportToExcel } from 'library';
import { MDialog } from 'common';

import { useUserRolePermissions } from 'hooks';

import { AuthContext } from 'authentication/AuthContext';

const DesktopMenuItems = ({ createNewPto, fetchCSVReport }) => {
  const { isProductOwnerManage, isInventoryOwner } = useUserRolePermissions();
  const { affiliates } = useContext(AuthContext);

  const [showDatePicker, setShowDatePicker] = useState(false);
  const [startDate, setStartDate] = useState(startOfToday());
  const [endDate, setEndDate] = useState(startOfTomorrow());

  const downloadBlob = (blob, filename) => {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
  };

  const downloadCSVreport = async () => {
    try {
      const response = await fetchCSVReport({
        affiliates: affiliates.map(a => ({
          customerIdName: a.customerIdName,
          dataCompanyId: a.dataCompanyId,
        })),
        endDate,
        startDate,
      });
      const blob = await new Blob([response.data], { type: 'text/csv' });
      const filename = `PTO_report_${format(parseISO(startDate), 'yyyy-MM-dd')}_to_${format(
        parseISO(endDate),
        'yyyy-MM-dd'
      )}.csv`;
      await downloadBlob(blob, filename);
      await setShowDatePicker(false);
    } catch (error) {
      /* do nothing */
    }
  };

  return (
    <Box
      sx={{
        alignItems: 'center',
        backgroundColor: 'surface.light',
        display: 'flex',
        justifyContent: 'space-between',
        left: 300,
        pl: 1.5,
        position: 'fixed',
        pr: 3,
        py: 3,
        top: 48,
        whiteSpace: 'nowrap',
        width: 'calc(100% - 300px)',
        zIndex: 3,
      }}
    >
      <Typography variant="h5">Search Product Transfer Orders</Typography>
      <Box>
        <IconButton
          aria-label="Export to Excel"
          onClick={() => setShowDatePicker(true)}
          size="large"
          sx={{
            background: 'white',
            borderRadius: 24,
            boxShadow: 1,
            marginRight: isProductOwnerManage ? 2 : 0,
            padding: '6px',
          }}
          variant="text"
        >
          <ExportToExcel />
        </IconButton>
        {isProductOwnerManage && isInventoryOwner && (
          <Button onClick={createNewPto} variant="contained">
            New Order
          </Button>
        )}
      </Box>

      <MDialog
        header="Select report date range"
        leftButtonAction={() => setShowDatePicker(false)}
        leftButtonText="Back"
        onClose={() => setShowDatePicker(false)}
        open={showDatePicker}
        rightButtonAction={() => downloadCSVreport()}
        rightButtonText="Download"
        sx={{ height: 500 }}
      >
        <Box alignItems="center" display="flex" justifyContent="space-between">
          <DatePicker
            label="Start Date"
            onChange={newValue => setStartDate(newValue.toJSON())}
            slotProps={{
              textField: {
                sx: { '& > div > input': { py: '12.5px' } },
              },
            }}
            value={parseISO(startDate)}
          />
          <Box sx={{ mx: 2 }}> to </Box>
          <DatePicker
            label="End Date"
            onChange={newValue => setEndDate(newValue.toJSON())}
            slotProps={{
              textField: {
                sx: { '& > div > input': { py: '12.5px' } },
              },
            }}
            value={parseISO(endDate)}
          />
        </Box>
      </MDialog>
    </Box>
  );
};

DesktopMenuItems.propTypes = {
  createNewPto: func.isRequired,
  fetchCSVReport: func.isRequired,
};

export default DesktopMenuItems;
